import React from 'react';

interface AutoLinkContentProps {
  children: React.ReactNode;
  className?: string;
  enabled?: boolean;
}

/**
 * Wrapper qui active le maillage automatique pour son contenu
 * Ajoute l'attribut data-auto-linking nécessaire au moteur de liens
 */
const AutoLinkContent: React.FC<AutoLinkContentProps> = ({
  children,
  className = '',
  enabled = true
}) => {
  if (!enabled) {
    return <div className={className}>{children}</div>;
  }

  return (
    <div 
      className={className}
      data-auto-linking="true"
    >
      {children}
    </div>
  );
};

export default AutoLinkContent;